import { useEffect, useState } from 'react'
import { Box, CircularProgress, List, ListItem, ListItemText, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getDelivery } from '../state/actions'
import { IRootReducerState } from 'state/reducers'

interface CustomerTabProps {
  customer?: {
    CustEosId: string
    CustNo: string
    CustName: string
    Location: string
    Street: string
    ZipCode: string
    OuName: string
    ShipToLoc: string
  } | null
  allowProceed: (allow: boolean) => void
}

const Delivery = (props: CustomerTabProps): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [deliveryData, setDeliveryData] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const ou_name = useSelector((state: IRootReducerState) => state.auth.user.ou_name)
  const AppId = useSelector((state: IRootReducerState) => state.auth.user.AppId)

  const getDeliveryFn = async () => {
    try {
      const result = await dispatch(
        getDelivery(
          props.customer?.CustNo as string,
          props.customer?.ShipToLoc as string,
          ou_name as string,
          String(AppId),
          props.customer?.CustEosId as string
        )
      )

      const deliveryData = result.Data
      setDeliveryData(deliveryData)
    } catch (error) {
      console.error('Error fetching customer profile:', error)
    } finally {
      setTimeout(() => {
        setLoading(false)
        props.allowProceed(true)
      }, 50)
    }
  }

  useEffect(() => {
    props.allowProceed(false)
    if (props.customer) {
      getDeliveryFn()
    } else {
      props.allowProceed(false)
    }
  }, [props.customer])

  if (!props.customer) {
    return <Box>Something went wrong..user not found</Box>
  }

  return (
    <Box>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
          <CircularProgress size={20} />
        </Box>
      ) : (
        <>
          <Typography variant='subtitle1' style={{ marginBottom: '22px', marginTop: '0px', fontSize: 20, fontWeight: 700 }}>
            {t('Customers.Delivery')}
          </Typography>
          {deliveryData.length > 0 && (
            <Typography variant='body1' sx={{ mb: 0, mt: -1 }}>
              Trip details available in EOS:
            </Typography>
          )}
          <List>
            {deliveryData.map((data, index) => (
              <ListItem key={index} sx={{ justifyContent: 'flex-end' }}>
                <ListItemText primary={`• ${data}`} />
              </ListItem>
            ))}
          </List>
        </>
      )}
    </Box>
  )
}

export default Delivery
